export const ADD_NEW_USER_BUNDLE = "ADD_NEW_USER_BUNDLE";
export const ADD_NEW_TOKEN_BUNDLE = "ADD_NEW_TOKEN_BUNDLE";
export const ADD_NEW_TOKEN_BUNDLE_END = "ADD_NEW_TOKEN_BUNDLE_END";
export const SET_TOKEN_DETAILS = "SET_TOKEN_DETAILS";
export const CLOSE_EDIT_TOKEN = "CLOSE_EDIT_TOKEN";
export const REFETCH_USER_BUNDLE_LIST = "REFETCH_USER_BUNDLE_LIST";
export const REFETCH_TOKEN_BUNDLE_LIST = "REFETCH_TOKEN_BUNDLE_LIST";

const initialState = {
  allUserBundles: [],
  allTokenBundles: [],
  addNewTokenBundle: false,
  addTokenBundleBtn: false,
  addNewUserBundle: false,
  refreshUserBundleList: false,
  refreshTokenBundleList: false,
  isLoading: true,

  bundle_amount: 0,
  bundle_token_limit: 0,
  bundle_title: "",
  bundle_status: "active",
  user_bundle_status: "active",
  bundle_token: 0,
  bundle_user_limit: 0,
  bundle_normal_user: 0,
  bundle_admin_user: 0,
  user_bundle_plan_id: 0,

  e_addNewTokenBundle: false,
  e_addTokenBundleBtn: false,
  e_addNewUserBundle: false,

  e_bundle_amount: 0,
  e_bundle_token_limit: 0,
  e_bundle_title: "",
  e_bundle_status: "",
  tokenBundleid: 0,

  e_bundle_token: 0,
  e_bundle_user_limit: 10,
  e_bundle_normal_user: 0,
  e_bundle_admin_user: 0,

  all_user_bundle_purchases: [],
  isUserBundlePurchasesLoading: false,
  sTotal_user_bundle: 0,
  sUserBundleRefetch: false,
  sPage: 0,
  isUserBundleModalOpen: false,
  UserBundleSelected: {},
  isUserBundleSubscriptionLoading: false,

  isTokenBundleSubscriptionLoading: false,
  all_tokenBundle_subscription: [],
  sTotal_tokenBundle: 0,
  sTokenBundleRefetch: false,
  sPageT: 0,
  isTokenBundleModalOpen: false,
  TokenBundleSelected: {},
  isTokenBundleSubscriptionsLoading: false,
  dummyLoad: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_TOKEN_DETAILS: {
      return { ...state, ...action.payload };
    }
    case ADD_NEW_TOKEN_BUNDLE: {
      return { ...state, addNewTokenBundle: true, addTokenBundleBtn: false };
    }
    case ADD_NEW_TOKEN_BUNDLE_END: {
      return {
        ...state,
        addNewTokenBundle: false,
        bundle_amount: 0,
        bundle_token_limit: 0,
        bundle_title: "",
        addTokenBundleBtn: false,
        addNewUserBundle: false,
        bundle_type: "",
        bundle_token: 0,
        bundle_user_limit: 10,
        bundle_interval: "",
        bundle_normal_user: 0,
        bundle_admin_user: 0,
        bundle_status: "active",
        user_bundle_status: "active",
      };
    }
    case ADD_NEW_USER_BUNDLE: {
      return { ...state, addNewUserBundle: true, addTokenBundleBtn: false };
    }
    case CLOSE_EDIT_TOKEN: {
      return {
        ...state,
        e_addNewUserBundle: false,
        e_bundle_status: "",
        e_addNewTokenBundle: false,
        e_bundle_amount: 0,
        e_bundle_token_limit: 0,
        e_bundle_title: "",
        e_addTokenbundleBtn: false,
        e_bundle_type: "",
        e_bundle_token: 0,
        e_bundle_user_limit: 10,
        e_bundle_interval: "",
        e_bundle_normal_user: 0,
        e_bundle_admin_user: 0,
      };
    }
    case REFETCH_USER_BUNDLE_LIST: {
      return { ...state, refreshUserBundleList: true };
    }
    case REFETCH_TOKEN_BUNDLE_LIST: {
      return { ...state, refreshTokenBundleList: true };
    }
    default:
      return state;
  }
};
